import { type CarrierDef } from '../common.js'
import { password, username, userPassMap } from '../internal.js'

const credentialTypes = [username, password] as const

export type cgojCredType = (typeof credentialTypes)[number]
export const cgoj: CarrierDef<cgojCredType> = {
  name: 'Cargomatic',
  scac: 'cgoj',
  credentialTypes,
  legacyCredMap: [...userPassMap],
  engineLayers: ['rating', 'tracking'],
}
